import { Typography, Box, Modal, Stack } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import React, { useState } from "react";
import { AddressTestingStyles } from "../common/styles/AddressTesting.styles";
import CloseIcon from "@mui/icons-material/Close";
import clsx from "clsx";
import { SxProps, Theme } from "@mui/system";
type Props = {
  address: string;
  open: boolean;
  isMobile: boolean;
};

const mobileStyle: SxProps<Theme> = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  bgcolor: "background.paper",
  borderRadius: "10px",
};

const desktopStyle: SxProps<Theme> = {
  position: "absolute",
  top: "50%",
  left: "50%",
  height: "auto",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "10px",
  display: "flex",
  flexDirection: "column",
};

const AddressSuccessScreen = (props: Props) => {
  const { address, isMobile } = props;
  const style = isMobile ? mobileStyle : desktopStyle;
  const [open, setOpen] = useState(true);
  const classes = AddressTestingStyles();
  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Box sx={style}>
        <Box
          className={clsx(classes.titleContainer, {
            [classes.titleContainerDesktop]: !isMobile,
          })}
        >
          <CloseIcon onClick={() => setOpen(false)} className={classes.closeIcon} />
          <Typography id="modal-title" variant="h6" component="h2">
            {"Address Verified!"}
          </Typography>
          <div></div>
        </Box>
        <Stack direction="row" alignItems="center" sx={{ padding: "24px 28px" }}>
          <CheckCircleIcon className={classes.verifiedIcon} />
          <Typography
            sx={{
              pl: "12px",
              fontSize: "14px",
              lineHeight: "17px",
              fontWeight: 400,
            }}
          >
            {`Your address ${address} is successfully verified!`}
            <br />
            {`You may now request for a withdrawal with this address from your broker.`}
          </Typography>
        </Stack>
      </Box>
    </Modal>
  );
};

export default AddressSuccessScreen;
